import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./CustomColorsIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./CustomColorsList'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./CustomColorsFormPage'),
  loading: () => <Loading withContentWrapper />,
});
